let rf_itemIndex = 1;

/* Add Item */
function rf_addItem() {
  const wrapper = document.getElementById('items-wrapper');
  const item = document.createElement('div');
  item.className = 'item grid gap-y-3 p-6 bg-gray-900 rounded-xl';
  item.dataset.itemIndex = rf_itemIndex;
  item.innerHTML = `
    <input
      class="focus-offset w-full h-14 py-1 px-5 text-gray-100 placeholder:text-gray-200 bg-white border border-gray-800 rounded-lg"
      type="text"
      name="items[${rf_itemIndex}][product_name]"
      placeholder="SKU or product name"
      required
    >
    <input
      class="focus-offset w-full h-14 py-1 px-5 text-gray-100 placeholder:text-gray-200 bg-white border border-gray-800 rounded-lg"
      name="items[${rf_itemIndex}][quantity]"
      type="number"
      min="1"
      placeholder="Quantity"
      required
    >
    <div class="relative">
      <select
        class="focus-offset w-full min-h-14 pl-5 pr-15 text-base text-gray-100 placeholder:text-gray-200 bg-white border border-gray-800 rounded-lg cursor-pointer appearance-none"
        name="items[${rf_itemIndex}][reason]"
        required
        onchange="rf_toggleOther(this, ${rf_itemIndex})"
      >
        <option value="">Select reason</option>
        <option>Change of mind</option>
        <option>Incorrect item received</option>
        <option>Item arrived damaged</option>
        <option>Item faulty / not working</option>
        <option>Size doesn't fit</option>
        <option>Item not as described</option>
        <option>Duplicate order</option>
        <option>Late delivery - no longer needed</option>
        <option>Gift return</option>
        <option>Other</option>
      </select>
      <span class="absolute top-1/2 right-3 flex items-center justify-center size-9 *:size-5 text-brand-primary pointer-events-none -translate-y-1/2"><svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg></span>
    </div>
    <input
      id="other_reason_${rf_itemIndex}"
      class="rf-hidden"
      type="text"
      name="items[${rf_itemIndex}][other_reason]"
      placeholder="Please specify"
    >
    <div class="flex justify-end">
      <button
        id="rf-remove-item"
        class="link"
        type="button"
        onclick="rf_removeItem(${rf_itemIndex})"
      >Remove item</button>
    </div>
  `;
  wrapper.appendChild(item);
  rf_itemIndex++;
}

function rf_removeItem(item) {
  const itemToRemove = document.querySelector(
    `#items-wrapper [data-item-index="${item}"]`
  );
  if (itemToRemove) {
    itemToRemove.remove();
    rf_itemIndex--;
  }
}

function rf_toggleOther(selectEl, index) {
  const otherInput = document.getElementById('other_reason_' + index);
  if (selectEl.value === 'Other') {
    otherInput.classList.remove('rf-hidden');
  } else {
    otherInput.classList.add('rf-hidden');
  }
}

document
  .getElementById('return-form')
  .addEventListener('submit', async function (event) {
    event.preventDefault();

    const form = this;
    const messageBox = document.getElementById('return-message');
    const submitBtn = form.querySelector('[type="submit"]');

    messageBox.classList.add('rf-hidden');

    submitBtn.disabled = true;
    submitBtn.innerText = 'Sending...';

    const formData = new FormData(form);

    try {
      const response = await fetch('/apps/returns/returns', {
        method: 'POST',
        body: formData
      });
      const data = await response.json();

      if (data.success === true) {
        messageBox.textContent = data.message;
        messageBox.className = 'return-form-message success';
        messageBox.classList.remove('rf-hidden');
        form.reset();
      } else {
        messageBox.textContent = data.message;
        messageBox.className = 'return-form-message error';
        messageBox.classList.remove('rf-hidden');
      }
    } catch (error) {
      messageBox.textContent = 'Something went wrong, please try again.';
      messageBox.className = 'return-form-message error';
      messageBox.classList.remove('rf-hidden');
    }

    submitBtn.disabled = false;
    submitBtn.innerText = 'Submit return request';

    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
